import createEnum from 'scripts/lib/create_enum';

import createModel, { prop } from './lib/create_model';

const RatingValue = createEnum('thumbs_up', 'thumbs_down');
const RatingReason = createEnum('incorrect_or_incomplete', 'slow_or_buggy', 'style_or_tone', 'other');

const TeamAssistRating = createModel({
  modelName: 'TeamAssistRating',

  properties: {
    comment: prop(String).default(null),
    reason: prop(String)
      .oneOf(...Object.values(RatingReason))
      .default(null),
    value: prop(String).oneOf(...Object.values(RatingValue)).isRequired,
  },

  statics: {
    Reason: RatingReason,
    Value: RatingValue,
  },
});

export default TeamAssistRating;
